import { Image } from "primereact/image";
import { useNavigate } from "react-router-dom";

import Logo from "assets/images/logo_small.svg";
import { altImmagineLogo } from "_constants";

export const ToolbarStartContent = () => {
  const navigate = useNavigate();

  return (
    <Image src={Logo} alt={altImmagineLogo} onClick={() => navigate("/bo")} />
  );
};
